import React from 'react'
import PropTypes from 'prop-types'
import {Image, Text, Link as ChakraLink, Button} from '@chakra-ui/react'
import {Link as RouteLink} from 'react-router-dom'
import Link from '@salesforce/retail-react-app/app/components/link'
import {noop} from '@salesforce/retail-react-app/app/utils/utils'

const DrawerButtonCard = ({
    title,
    url,
    image,
    svg,
    isAbsolute = false,
    isLink = false,
    handleClick = noop,
    customTitleColor,
}) => {
    const handleCardClick = (e) => {
        handleClick(e)
    }

    const Card = (
        <Button onClick={handleCardClick} variant="outline-not-rounded" size="large" width="100%">
            {image && (
                <Image
                    src={image?.url}
                    alt={title}
                    loading="lazy"
                    width="iconsSize.small"
                    height="iconsSize.small"
                    color={customTitleColor ? customTitleColor : 'foreground.neutral.default'}
                />
            )}
            {!image && svg}

            <Text
                color={customTitleColor ? customTitleColor : 'foreground.neutral.default'}
                noOfLines={2}
                minWidth={0}
                whiteSpace="normal"
                overflowWrap="anywhere"
            >
                {title}
            </Text>
        </Button>
    )

    if (!isLink) {
        return Card
    }

    if (isAbsolute) {
        return (
            <ChakraLink
                href={url}
                _hover={{textDecoration: 'none'}}
                isExternal
                target="_blank"
                rel="noreferrer"
            >
                {Card}
            </ChakraLink>
        )
    }

    return (
        <Link as={RouteLink} to={url} _hover={{textDecoration: 'none'}}>
            {Card}
        </Link>
    )
}

DrawerButtonCard.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    image: PropTypes.shape({
        url: PropTypes.string.isRequired,
    }),
    svg: PropTypes.element,
    isAbsolute: PropTypes.bool,
    isLink: PropTypes.bool,
    customTitleColor: PropTypes.string,
    handleClick: PropTypes.func,
    variant: PropTypes.oneOf(['default', 'filter', 'promo', 'secondary', 'simpleLink', 'variant']),
}

export default DrawerButtonCard
